import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {ScenarioParameters} from './ScenarioParameters';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class Scenario extends BasicEntity {
code: string;
description: TranslatedEmb;
label: TranslatedEmb;
parameters: ScenarioParameters;
parentCode: string;
visionCode: string;
}

